import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import styles from './style.js';

class EditDialog extends React.Component {
  state = {
    open: false,
    fieldDatas:[]
  };
  componentWillMount() {
    const { selectedData } = this.props;
    this.setState({ fieldDatas: selectedData });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleApprove = () => {
    this.props.handleApprove();
  };

  handleChange = event => {
    const { selectedData,fields } = this.props;
    
    const fieldName = event.target.id;
    const fieldValue = event.target.value;

    Array.prototype.forEach.call(fields, value => {
      if (value.field == fieldName) {
        selectedData[fieldName]= fieldValue;   
      }
    });

    this.setState({ fieldDatas: selectedData });
  };

  handleSelectChange = event => {
    const { selectedData,fields } = this.props;
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    //Seçilen id'ye göre obje bulunur.Grid render ettiğinde texti göstermesi ayarlandı.
    let isBreak=false;
    for (let i = 0; i < fields.length; i++) {
      if(isBreak)
        break;

      let value=fields[i];
      if (value.field == fieldName) {
        if(value.dataList!=undefined){
          for (let j = 0; j < value.dataList.length; j++) {
            let valueSub=value.dataList[j];
            if (valueSub[value.keyField] == fieldValue) {
              selectedData[fieldName]= valueSub;
              isBreak=true;
              break;
            }
          }
        }
      }
    } 

    this.setState({ fieldDatas: selectedData });
  };

  render() {
    const { fullScreen,fields } = this.props;
    const { fieldDatas } = this.state;

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={this.props.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title"><div style={styles.title}>{this.props.title}</div></DialogTitle>
          <DialogContent>
            <DialogContentText>
              {/* {this.props.text} */}
              <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {fields.filter(item => !item.hide).map((item) =>
                  {switch(item.type) {
                    case 'singleSelect':
                      return <Grid item xs={12}><InputLabel id={item.field+"Lbl"} style={styles.label}>{item.labelText}</InputLabel>
                      <Select
                      className='customSelect'
                      fullWidth
                      labelId={item.field+"Lbl"}
                      value={fieldDatas[item.field]!=undefined?fieldDatas[item.field][item.keyField]:fieldDatas[item.field]}
                      name={item.field}
                      sx={styles.selectField}
                      onChange={this.handleSelectChange}>
                      {item.dataList.map((lItem) => (
                        <MenuItem value={lItem[item.keyField]}>
                          <div style={styles.selectField}>{lItem[item.valueField]}</div>
                        </MenuItem>
                      ))}
                    </Select></Grid>;
                    default:
                      return <Grid item>
                          <TextField sx = {styles.textField} id={item.field} label={item.field} variant="outlined" value={fieldDatas[item.field]} onChange={this.handleChange}/>
                        </Grid>;
                }}
              )}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} style={styles.cancelButton}>
              İptal
            </Button>
            <Button onClick={this.handleApprove} style={styles.saveButton} autoFocus>
              Ekle
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EditDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withMobileDialog()(EditDialog);
